var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlueFlowers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 393.377,
    height: 473.792,
    viewBox: "0 0 393.377 473.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1572",
    "data-name": "Group 1572",
    transform: "translate(3.715 -285.172) rotate(31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7346",
    "data-name": "Path 7346",
    d: "M261.936,439.374s6.838-54.009,52.225-122.633C341.4,275.567,382.5,229.133,444.34,185.947",
    transform: "translate(77.842 130.347)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7347",
    "data-name": "Path 7347",
    d: "M242.2,178.246s63.6,39.734,104.76,151.292",
    transform: "translate(45.045 117.55)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7348",
    "data-name": "Path 7348",
    d: "M262.421,305.838S258.3,180.844,322.5,134.373",
    transform: "translate(78.56 44.646)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7349",
    "data-name": "Path 7349",
    d: "M262.991,116.073s-9.6,48.632,27.482,84.11C290.473,200.183,308.03,144.977,262.991,116.073Z",
    transform: "translate(77.737 14.236)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7350",
    "data-name": "Path 7350",
    d: "M273.665,155.483s40.551,28.507,88.025,9C361.69,164.488,318.355,126.042,273.665,155.483Z",
    transform: "translate(97.332 61.281)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7351",
    "data-name": "Path 7351",
    d: "M248.112,156.137s3.308,37.027,37.464,54.773C285.576,210.91,286.611,167.476,248.112,156.137Z",
    transform: "translate(54.871 80.811)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7352",
    "data-name": "Path 7352",
    d: "M300.4,170.4s-9.6,48.629,27.482,84.107C327.879,254.511,345.436,199.307,300.4,170.4Z",
    transform: "translate(139.895 104.519)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7353",
    "data-name": "Path 7353",
    d: "M311.07,209.814s40.554,28.507,88.028,9C399.1,218.819,355.763,180.373,311.07,209.814Z",
    transform: "translate(159.489 151.564)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7354",
    "data-name": "Path 7354",
    d: "M282.351,232.637s3.308,37.03,37.464,54.773C319.815,287.41,320.85,243.979,282.351,232.637Z",
    transform: "translate(111.766 207.932)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7355",
    "data-name": "Path 7355",
    d: "M263.126,188.118s35.185,12,65.262-12.02C328.388,176.1,289.11,157.532,263.126,188.118Z",
    transform: "translate(79.82 104.705)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7356",
    "data-name": "Path 7356",
    d: "M248.875,228.416s34.3,14.347,65.925-7.586C314.8,220.83,276.866,199.654,248.875,228.416Z",
    transform: "translate(56.139 175.831)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7357",
    "data-name": "Path 7357",
    d: "M223.367,203.944s43.12,18.041,82.888-9.537C306.255,194.407,258.56,167.782,223.367,203.944Z",
    transform: "translate(13.752 128.711)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7358",
    "data-name": "Path 7358",
    d: "M276.774,255.043s27.03-25.526,19.814-63.333C296.588,191.71,261.842,217.789,276.774,255.043Z",
    transform: "translate(96.304 139.923)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7359",
    "data-name": "Path 7359",
    d: "M290.874,171.55s-16.726-55.566-5.507-58.861,7.258,3.963,25.049,7.551,47.147,6.633,49.154,14.674-10.6,10.056-23.231,17.889S299.681,182.048,290.874,171.55Z",
    transform: "translate(110.342 7.223)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7360",
    "data-name": "Path 7360",
    d: "M286.837,173.118c-.548-7.618,1.23-16.543,1.9-24.5.61-7.256,4.493-51.169,18.081-39,2.872,2.574,3.066,7.08,4.674,10.775,1.831,4.214,5.1,7.072,8.307,9.587,4.315,3.383,8.837,6.572,11.232,12.353a2.562,2.562,0,0,1,.256,1.485,4.106,4.106,0,0,1-1.059,1.8c-5.39,6.308-39.492,47.78-43.442,33.16",
    transform: "translate(119.048 0)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7361",
    "data-name": "Path 7361",
    d: "M335.917,229.066s-19.71-65.47-6.489-69.356,8.555,4.669,29.516,8.9S414.5,176.425,416.86,185.9s-12.486,11.85-27.37,21.078S346.3,241.438,335.917,229.066Z",
    transform: "translate(182.411 85.109)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7362",
    "data-name": "Path 7362",
    d: "M331.159,230.912c-.644-8.973,1.451-19.492,2.238-28.861.719-8.552,5.294-60.3,21.3-45.952,3.386,3.034,3.617,8.344,5.51,12.7,2.159,4.967,6.007,8.334,9.79,11.3,5.084,3.982,10.41,7.74,13.237,14.552a3.069,3.069,0,0,1,.3,1.751,4.827,4.827,0,0,1-1.248,2.129c-6.351,7.432-46.532,56.3-51.185,39.071",
    transform: "translate(192.669 76.598)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7363",
    "data-name": "Path 7363",
    d: "M282.719,212.913s-26.093-61.352-35.27-59.862-1.927,6.923-10.676,17.908-25.087,26.29-21.051,34.993,13.234,5.379,26.274,7.732S284.124,226.876,282.719,212.913Z",
    transform: "translate(0 75.638)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7364",
    "data-name": "Path 7364",
    d: "M271.865,210.4c-4.666-7.676-11.648-15.656-17.293-23.152-5.153-6.838-36.457-48.142-36.939-30.532-.1,3.724,2.742,8.211,4.168,12.5a29.814,29.814,0,0,1,1.115,12.864c-.471,5.118-1.2,10.136,1.107,16.8a4.564,4.564,0,0,0,.817,1.557,5.879,5.879,0,0,0,1.85,1.323c7.514,3.9,56.088,30.125,48.938,14.171",
    transform: "translate(4.218 74.578)",
    fill: "none",
    stroke: "#bacdd8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFlowers);
export default __webpack_public_path__ + "static/media/blue-flowers.b5f46e2d.svg";
export { ForwardRef as ReactComponent };